module.exports = __webpack_public_path__ + "img/04green.490fbedb.gif";